import {
    PagedResponse,
    PatchWithMeta,
    QueryParams,
} from '@ofqual/portal-core/core/types';
import {AnyAction} from 'redux';
import {LcmModel, LcmStatus} from '../domain/LcmModel';
import {MODULE_NAME} from '../moduleName';
import {LcmExternalCounselRequest} from '../domain/LcmExternalRequest';
import {LcmTimeRecord} from '../domain/LcmTimeRecord';
import {CaseNoteModel} from '../domain/CaseNoteModel';
import {InternalMessageModel} from '../domain/InternalMessageModel';
import {CommunicationType} from "../domain/FutureEventModel";

export interface ActionPayload<T> extends AnyAction {
    type: string;
    payload: T;
}

export const LOADED_ITEMS = `${MODULE_NAME}/LOADED_ITEMS`;
export const LOADING_ITEMS = `${MODULE_NAME}/LOADING_ITEMS`;

export const LOADED_ITEM = `${MODULE_NAME}/LOADED_ITEM`;
export const LOADING_ITEM = `${MODULE_NAME}/LOADING_ITEM`;
export const SAVED_ITEM = `${MODULE_NAME}/SAVED_ITEM`;

export const UPDATING_ITEM = `${MODULE_NAME}/UPDATING_ITEM`;
export const UPDATING_ITEM_VALIDATION_FAIL = `${MODULE_NAME}/UPDATING_ITEM_VALIDATION_FAIL`;

export const INPUTTING_ITEM = `${MODULE_NAME}/INPUTTING_ITEM`;
export const CREATING_ITEM = `${MODULE_NAME}/CREATING_ITEM`;
export const CREATING_ITEM_VALIDATION_FAIL = `${MODULE_NAME}/CREATING_ITEM_VALIDATION_FAIL`;
export const CREATED_ITEM = `${MODULE_NAME}/CREATED_ITEM`;

export const REQUESTING_EXTERNAL_COUNSEL = `${MODULE_NAME}/REQUESTING_EXTERNAL_COUNSEL`;
export const REJECTING_EXTERNAL_COUNSEL = `${MODULE_NAME}/REJECTING_EXTERNAL_COUNSEL`;
export const ACCEPTING_EXTERNAL_COUNSEL = `${MODULE_NAME}/ACCEPTING_EXTERNAL_COUNSEL`;

export const ADD_TIME_RECORD = `${MODULE_NAME}/ADD_TIME_RECORD`;
export const ADD_CASE_NOTE = `${MODULE_NAME}/ADD_CASE_NOTE`;

export const ATTACHING_EMAIL = `${MODULE_NAME}/ATTACHING_EMAIL`;

export const ADD_INTERNAL_MESSAGE = `${MODULE_NAME}/ADD_INTERNAL_MESSAGE`;

export const UPDATE_LCM_STATUS = `${MODULE_NAME}/UPDATE_LCM_STATUS`;
export const CREATE_FUTURE_EVENT = `${MODULE_NAME}/CREATE_FUTURE_EVENT`;

export const loadedItems = (payload: PagedResponse<LcmModel>) => ({
    type: LOADED_ITEMS,
    payload,
});
export const loadingItems = (payload: QueryParams) => ({
    type: LOADING_ITEMS,
    payload,
});

export const loadedItem = (item: LcmModel) => ({
    type: LOADED_ITEM,
    payload: item,
});

export const savedItem = (item: LcmModel) => ({
    type: SAVED_ITEM,
    payload: item,
});

export const loadingItem = (id: string) => ({
    type: LOADING_ITEM,
    payload: id,
});

export const updatingItem = (
    id: string,
    patchWithMeta: PatchWithMeta<LcmModel>,
) => ({
    type: UPDATING_ITEM,
    payload: {id, patchWithMeta},
});

export const createItem = (item: LcmModel) => ({
    type: CREATING_ITEM,
    payload: item,
});

export const inputtingItem = () => ({
    type: INPUTTING_ITEM,
});

export const requestExternalCounsel = (
    id: string,
    req: LcmExternalCounselRequest,
) => ({
    type: REQUESTING_EXTERNAL_COUNSEL,
    payload: {id, req},
});

export const requestExternalCounselReject = (
    lcmId: string,
    lcmExternalCounselRequestId: string,
) => ({
    type: REJECTING_EXTERNAL_COUNSEL,
    payload: {lcmId, lcmExternalCounselRequestId},
});

export const requestExternalCounselAccept = (
    lcmId: string,
    lcmExternalCounselRequestId: string,
) => ({
    type: ACCEPTING_EXTERNAL_COUNSEL,
    payload: {lcmId, lcmExternalCounselRequestId},
});

export const addTimeRecord = (lcmId: string, timeRecord: LcmTimeRecord) => ({
    type: ADD_TIME_RECORD,
    payload: {lcmId, timeRecord},
});

export const addCaseNote = (lcmId: string, caseNote: CaseNoteModel) => ({
    type: ADD_CASE_NOTE,
    payload: {lcmId, caseNote},
});

export const addInternalMessage = (
    lcmId: string,
    internalMessage: InternalMessageModel
) => ({
    type: ADD_INTERNAL_MESSAGE,
    payload: {lcmId, internalMessage},
});

export const attachEmail = (id: string, file: File) => ({
    type: ATTACHING_EMAIL,
    payload: {
        id,
        file,
    },
});

export const updateLcmStatus = (lcmId: string, lcmStatus: LcmStatus, caseNote: string) => ({
    type: UPDATE_LCM_STATUS,
    payload: {lcmId, lcmStatus, caseNote},
});

export const createFutureEvent = (lcmId: string, dateTime: Date,eventType: string,communicationType:CommunicationType, note: string) => ({
    type: CREATE_FUTURE_EVENT,
    payload: {lcmId, dateTime, eventType,communicationType,note},
});
